import React from 'react';
import { ButtonLink } from '@blueprint/ui';
import { FC } from 'react';
import { BottomMenuWrapper } from './BottomMenu.styles';

type Props = {
    signInUrl: string;
};

const BottomMenu: FC<Props> = ({ signInUrl }) => (
    <BottomMenuWrapper>
        <li>
            <ButtonLink
                variant="tertiary"
                href={signInUrl}
                data-testid="header-profile-sign-in"
                data-header-signin="/signin/?page_after_login={URL}&return_url={URL}"
                data-track-category="User Account"
                data-track-action="clickthrough"
                data-track-label="user account>sign in"
            >
                Sign in
            </ButtonLink>
        </li>
    </BottomMenuWrapper>
);

export default BottomMenu;
